import type { FormCompositionHook } from '@ipfabric/ui-components/utils/formSnippets/useFormComposition';

type Props = {
  formComposition: FormCompositionHook<'deviceCredentials'>;
};

export const DeviceCredentialsSubTab = ({ formComposition }: Props) => {
  return (
    <div className='flex flex-col flex-1 gap'>
      {formComposition.renderGroup('deviceCredentials')}
    </div>
  );
};
